import type { BaseSelectionResponse } from "@frend-digital/centra-types/selection";
import { createContext } from "react";
import type { CheckoutErrorTypes } from "../errors";
import type { Action, SelectionChangeReason } from "./actions";

export type CheckoutErrorType = null | CheckoutErrorTypes | Error;
export interface CheckoutState {
  error: CheckoutErrorType;
}

export interface CheckoutContext {
  state: CheckoutState;
  token: string | undefined | null;

  centraUrl: string;
}

export const CheckoutContext = createContext<CheckoutContext>(null!);
export const CheckoutDispatchContext = createContext<React.Dispatch<Action>>(
  null!
);

export type SelectionChangeHandler = (
  selection: BaseSelectionResponse,
  reason: SelectionChangeReason
) => void;

export type CheckoutDispatchHandlers = {
  onError?: (action: Action) => void;
  onSelectionChange?: SelectionChangeHandler;
};

export const createCheckoutReducer = ({
  onError,
  onSelectionChange,
}: CheckoutDispatchHandlers) =>
  function checkoutReducer(state: CheckoutState, action: Action) {
    switch (action.type) {
      case "PAYMENT_ERROR":
      case "ADDRESS_ERROR":
      case "INGRID_ERROR":
      case "PAYMENT_INIT_ERROR":
        onError?.(action);
        return {
          ...state,
          error: action.payload,
        };

      case "RESET_ERROR":
        return {
          ...state,
          error: null,
        };
      case "SELECTION_CHANGE":
        onSelectionChange?.(action.payload, action.reason);
        return state;
      default:
        return state;
    }
  };
